import React from 'react'
import PropTypes from 'prop-types'
import CancelableChip from '../../sitewide/Chips/CancelableChip'
import SelectableChip from '../../sitewide/Chips/SelectableChip'

const unique = (value, index, self) => self.indexOf(value) === index

const ModalContent = ({
  handleAddChip,
  handleRemoveChip,
  handleSearch,
  listType,
  searchTerm,
  selectedTypes,
  sliderAppointmentTypeIds,
  sliderAppointmentTypes,
}) => {
  const isTops = process.env.REACT_APP_IS_TOPS
  const filterTypeByTerm = id =>
    (sliderAppointmentTypes[id].code &&
      sliderAppointmentTypes[id].code
        .toLowerCase()
        .includes(searchTerm.toLowerCase())) ||
    (sliderAppointmentTypes[id].description &&
      sliderAppointmentTypes[id].description
        .toLowerCase()
        .includes(searchTerm.toLowerCase()))
  return (
    <div>
      <span className="sliderTitle">{`Selected ${listType}`}</span>
      <div className="chipContainer">
        <div className="chipScrollBox">
          {!!selectedTypes.length &&
            selectedTypes
              .filter(unique)
              .map(typeId => (
                <CancelableChip
                  key={typeId}
                  description={sliderAppointmentTypes[typeId].description}
                  handleRemoveChip={() => handleRemoveChip(typeId)}
                  id={typeId}
                  title={isTops ? null : sliderAppointmentTypes[typeId].code}
                />
              ))}
        </div>
      </div>
      <span className="sliderTitle">{`All ${listType}`}</span>
      <div className="searchFilter">
        <label htmlFor="search">Search:</label>
        <input
          type="text"
          name="search"
          onChange={e => handleSearch(e)}
          value={searchTerm}
        />
      </div>
      <div className="chipContainer">
        <div className="chipScrollBox">
          {!!sliderAppointmentTypeIds.length &&
            sliderAppointmentTypeIds
              .filter(unique)
              .filter(filterTypeByTerm)
              .map(typeId => (
                <SelectableChip
                  key={typeId}
                  description={sliderAppointmentTypes[typeId].description}
                  handleAddChip={handleAddChip}
                  id={typeId}
                  title={isTops ? null : sliderAppointmentTypes[typeId].code}
                  usedChipTypes={selectedTypes}
                />
              ))}
        </div>
      </div>
    </div>
  )
}

ModalContent.propTypes = {
  handleAddChip: PropTypes.func.isRequired,
  handleRemoveChip: PropTypes.func.isRequired,
  handleSearch: PropTypes.func.isRequired,
  listType: PropTypes.string.isRequired,
  searchTerm: PropTypes.string.isRequired,
  sliderAppointmentTypeIds: PropTypes.arrayOf(PropTypes.string),
  sliderAppointmentTypes: PropTypes.objectOf(
    PropTypes.shape({
      code: PropTypes.string,
      description: PropTypes.string,
      id: PropTypes.string,
    }),
  ),
  selectedTypes: PropTypes.arrayOf(PropTypes.string),
}

export default ModalContent



// WEBPACK FOOTER //
// ./src/components/Settings/MessageSettingApptTypePicker/ModalContent.js